import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_33: FaireProductEntity = {
  token: "legacy_prod_abbott-33",
  type: "product",
  name: 'Cat Face Measuring Tape 2.5" D',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7faf4648e86e3d51103907e4296dbd634e684729989649961b1b5b8a0508eea4.jpeg",
  priceDollars: 8,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
